import { http } from '@/utils/axios'

/**
 * @msg: 获取报名列表
 */
export function getApplyList(data) {
    return http({
        url: http.baseUrl('userApprove/elAlbumApprove'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 获取报名列表
 */
 export function getApplyCount(data) {
    return http({
        url: http.baseUrl('userApprove/elAlbumApproveCount'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 获取用户报名信息
 */
export function getRegistUserInfo(data) {
    return http({
        url: http.baseUrl('applyUser/getUserInfo'),
        method: 'get',
        params: http.params(data),
    })
}



